import { OutboundTripDto } from 'dtos/outboundTrips'
import { BasicCompanyDtoValidator } from 'validators/companies'
import * as yup from 'yup'

export const OutboundTripDtoValidator = yup.object<OutboundTripDto>({
  outboundTripNumber: yup.string().max(50, 'Outbound Trip # cannot be more than 50 characters.').required('Outbound Trip # is required.'),
  outboundTripDate: yup.date().typeError('Outbound Trip Date is required.').required('Outbound Trip Date is required.'),
  outboundTransporterCompany: BasicCompanyDtoValidator('Outbound Transporter Company')
})
